import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  ModalProps,
  Modal as CharkaModal,
} from "@chakra-ui/react";
import React from "react";

interface MyModalProps extends ModalProps {
  title: string;
  submitBtnText?: string;
  cancelBtnText?: string;
  disableSubmit?: boolean;
  loadingSubmit?: boolean;
  disabledCloseOutSide?: boolean;
  closeable?: boolean;
  showCancelBtn?: boolean;
  onSubmit?: () => void;
  isHide?: boolean;
}
const MyModal = (props: MyModalProps) => {
  const {
    title,
    onClose,
    children,
    onSubmit,
    submitBtnText,
    loadingSubmit,
    disableSubmit,
    cancelBtnText,
    disabledCloseOutSide,
    closeable = true,
    showCancelBtn = true,
  } = props;

  return (
    <CharkaModal
      {...props}
      onClose={disabledCloseOutSide ? () => { } : onClose}>
      <ModalOverlay data-testid="modal-overlay" />
      <ModalContent>
        <ModalHeader padding="24px 0 16px 32px">{title}</ModalHeader>
        {closeable && (
          <ModalCloseButton
            onClick={onClose}
            _focus={{ boxShadow: "none", outline: "none" }}
            mt="4px"
          />
        )}

        <ModalBody padding={"12px 32px"}>{children}</ModalBody>

        <ModalFooter
          paddingEnd={"32px"}
        >
          {showCancelBtn && (
            <Button
              data-testid="modal-cancel-btn"
              variant="outline"
              mr={3}
              onClick={onClose}
              isDisabled={loadingSubmit}
            >
              {cancelBtnText ?? "Close"}
            </Button>
          )}

          {onSubmit && (
            <Button
              data-testid="modal-submit-btn"
              isLoading={loadingSubmit}
              disabled={disableSubmit}
              colorScheme="blue"
              onClick={onSubmit}
              minWidth="80px"
            >
              {submitBtnText ?? "Submit"}
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </CharkaModal>
  );
};

export default MyModal;
